export const isBetween = (x, min, max) => {
    return x >= min && x <= max;
}

export const calcDistanceBetweenTwoPoint = (point1, point2) => {
  return Math.abs(point1 - point2);
}
